import React from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';

import { Loader } from 'common/components/core/loader/Loader';
import theme from './Image.scss';
import { FontIcon } from 'react-toolbox/lib/font_icon';
import Tooltip from 'common/components/core/tooltip';

class Image extends React.Component {
    constructor(props) {
        super(props);
        this.state = { imageStatus: 'loading' };
    }

    handleImageLoaded = () => {
        this.setState({ imageStatus: 'loaded' }, () => {
            this.forceUpdate();
        });
    };

    handleImageErrored = () => {
        this.setState({ imageStatus: 'error' });
    };

    render() {
        const loaderActive = this.state.imageStatus === 'loading';
        const errorActive = this.state.imageStatus === 'error';
        const { className, src, children, theme, ...other } = this.props;
        return (
            <div
                data-toolbox="image-wrap"
                {...other}
                className={classnames(theme.imageWrap, className, {
                    [theme.loaderActive]: loaderActive
                })}
            >
                <a
                    href={src}
                    target="_blank"
                    className={classnames(theme.imageLink)}
                >
                    <img
                        src={src}
                        onLoad={this.handleImageLoaded}
                        onError={this.handleImageErrored}
                        className={classnames({ [theme.error]: errorActive })}
                    />
                </a>
                <Loader active={loaderActive} theme={theme} />
                <div
                    className={classnames(theme.errorWrap, {
                        [theme.errorActive]: errorActive
                    })}
                >
                    <FontIcon value="error" />
                </div>
                {children}
            </div>
        );
    }
}

const ThemedImage = themr('Image', theme)(Image);
const ThemedImageWithTooltip = Tooltip(ThemedImage);
const ImageWithTooltip = ({ src, theme }) => {
    return (
        <ThemedImageWithTooltip
            theme={theme}
            tooltip={
                <ThemedImage
                    theme={theme}
                    src={src}
                    className={theme.tooltipImage}
                />
            }
            src={src}
        />
    );
};
const ImageWithTooltipThemed = themr(
    'ImageWithTooltip',
    theme
)(ImageWithTooltip);
export { ThemedImage as Image, ImageWithTooltipThemed as ImageWithTooltip };
export default ThemedImage;
